var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row mb-3"},_vm._l((_vm.equipamentos),function(item){return _c('div',{key:item.codigo,staticClass:"col-xl-6"},[_c('Caixa',{attrs:{"equipamento":item.codigo.trim()}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }